import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Services } from "@/components/Services";
import { WhyChooseNC } from "@/components/WhyChooseNC";
import { HowItWorks } from "@/components/HowItWorks";
import { EstimateForm } from "@/components/EstimateForm";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";

function App() {
  return (
    <AuthProvider>
      <div className="min-h-screen overflow-x-hidden bg-background">
        <Header />
        <main>
          <Hero />
          <Services />
          <WhyChooseNC />
          <HowItWorks />
          <EstimateForm />
          <Contact />
        </main>
        <Footer />
        <WhatsAppFloat />
        <Toaster position="top-center" richColors />
      </div>
    </AuthProvider>
  );
}

export default App;
